// extracted by mini-css-extract-plugin
module.exports = {"btn":"SBotton_btn__3Fqsu","nBack":"SBotton_nBack__1SrxU","disabled":"SBotton_disabled___jnh4"};